"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAuthUrlToWebsite = void 0;

var _config = require("./config");

var _storage = require("./utils/storage");

const getAuthUrlToWebsite = toUrl => {
  const url = new URL((0, _config.singleAuthEndpoint)());
  url.searchParams.set('token', (0, _storage.getLegacyToken)());
  url.searchParams.set('referrer', toUrl);
  return url.toString();
};

exports.getAuthUrlToWebsite = getAuthUrlToWebsite;